import React, { useState, useEffect, useMemo, useCallback } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES } from '../../common_nextgen/utils/Constants';
import {
    isAddMode,
    isEditMode,
    isReadOnlyMode,
    navigateToPreviousPageWithParams,
  } from "../../common_nextgen/utils/UtilFunctions";  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import ConfirmationModal from '../../common_nextgen/common_components/Modal/ConfirmationModal';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';  
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";  

  
const formFields = [  
  {  
    section: 'Section 1',  
    name: 'cmmPatientPayTable',  
    label: 'Patient Pay Table',  
    fieldLabel: 'CMM Patient Pay Table',  
    type: 'text',  
    options: { readOnly: true },  
    fieldNature: 'Add: Read-only, Change: Read-only, View: Read-only',  
    position: [5, 20],  
  },  
  {  
    section: 'Section 1',  
    name: 'ps4PatPayDescription',  
    label: 'Description',  
    fieldLabel: 'PS4 Pat Pay Description',  
    type: 'text',  
    options: { readOnly: true },  
    fieldNature: 'Add: Read-only, Change: Read-only, View: Read-only',  
    position: [6, 20],  
  },  
  {  
    section: 'Section 1',  
    name: 'cmmStepNbr',  
    label: 'Step',  
    fieldLabel: 'Step',  
    type: 'number',  
    options: { min: { value: 0, message: 'MIN_0' }, max: { value: 99, message: 'MAX_99' } ,required: { value: true, message: 'Value required' } },  
    fieldNature: 'Add:Editable, Change: Read-only, View: Read-only',  
    position: [7, 20],  
  },  
  {  
    section: 'Section 1',  
    name: 'cmmDaysSupply',  
    label: 'Days Supply',  
    fieldLabel: 'Days Supply',  
    type: 'number',  
    options: { min: { value: 0, message: 'MIN_0' }, max: { value: 999, message: 'MAX_999' } ,required: { value: true, message: 'Value required' } },  
    fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
    position: [8, 20],  
  },  
  {  
    section: 'Minimum(Header)',  
    name: 'cmmBrandMinimumCopay',  
    label: 'Brand Amount',  
    fieldLabel: 'CMM Brand Minimum Copay',  
    type: 'number',
    fractionDigits: 2,  
    options: {min: { value: 0, message: 'MIN_0' }, max: { value: 99999.99, message: 'MAX_99999' } },  
    fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
    position: [9, 20],  
  },  
  {  
    section: 'Minimum(Header)',  
    name: 'cmmGenericMinimumCopay',  
    label: 'Generic Amount',  
    fieldLabel: 'CMM Brand Maximum Copay',  
    type: 'number',
    fractionDigits: 2,  
    options: {min: { value: 0, message: 'MIN_0' }, max: { value: 99999.99, message: 'MAX_99999' } },  
    fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
    position: [10, 20],  
  },  
  {  
    section: 'Maximum(Header)',  
    name: 'cmmBrandMaximumCopay',  
    label: 'Brand Amount',  
    fieldLabel: 'CMM Generic Minimum Copay',  
    type: 'number',
    fractionDigits: 2,  
    options: {min: { value: 0, message: 'MIN_0' }, max: { value: 99999.99, message: 'MAX_99999' } },  
    fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
    position: [11, 20],  
  },  
  {  
    section: 'Maximum(Header)',  
    name: 'cmmGenericMaximumCopay',  
    label: 'Generic Amount',  
    fieldLabel: 'CMM Generic Maximum Copay',  
    type: 'number',
    fractionDigits: 2,  
    options: {min: { value: 0, message: 'MIN_0' }, max: { value: 99999.99, message: 'MAX_99999' } },  
    fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
    position: [12, 20],  
  },  
  {  
    section: 'Audit Fields',  
    name: 'addDate',  
    label: 'Added',  
    fieldLabel: 'ADD Date',  
    type: 'date',  
    options: { readOnly: true },  
    fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
    position: [21, 21],  
  },  
  {  
    section: 'Audit Fields',  
    name: 'chgDate',  
    label: 'Changed',  
    fieldLabel: 'CHG Date',  
    type: 'date',  
    options: { readOnly: true },  
    fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
    position: [21, 41],  
  },  
  {  
    section: 'Audit Fields',  
    name: 'chgUserName',  
    label: 'User',  
    fieldLabel: 'CHG User Name',  
    type: 'text',  
    options: { readOnly: true },  
    fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
    position: [21, 58],  
  },  
];  
  
const screenInfo = {  
  ADD: ['Add Minimum/Maximum Copay Step', 'RCCMM005'],  
  CHANGE: ['Minimum/Maximum Copay Step Detail', 'RCCMM001'],  
  VIEW: ['Minimum/Maximum Copay Step Detail', 'RCCMM001I'],  
};  
  
const MinMaxCopayStepForm = ({ mode }) => {  
    const { axios_helper_no_header } = useAxios();

  const location = useLocation();  

  const stateVal = location.state;
  let [currentState = {}] = [...stateVal].reverse();
  let previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1); 
  const {
        selectedCopaySteps = [],
        previousScreen = ROUTE_PATHS.COPAY_SCHEDULE_STEPS,
        currentIndex: initialIndex = 0,
        paramsData    
    } = currentState;


  const navigateToPage = useCustomNavigate();  
  const [currentIndex, setCurrentIndex] = useState(initialIndex);  
  const [currentMode, setCurrentMode] = useState(mode);  
  const [initialFormData, setInitialFormData] = useState({});  
  const [dataForSubmission, setDataForSubmission] = useState({});  
  const [constraintErrors, setConstraintErrors] = useState([]);  
  const toast = useToast();  
  
  const handleBack = () => {  
    if (currentIndex < selectedCopaySteps.length - 1) {  
      setCurrentIndex(currentIndex + 1);  
      setCurrentMode(mode);  
    } else {  
      const lastStepNumber =
        selectedCopaySteps[currentIndex]?.cmmStepNbr || "";
      const updatedParamsData = {
        ...currentState.paramsData,
        cmmStepNbr: lastStepNumber,
      };
      navigateToPreviousPageWithParams(
        navigateToPage,
        previousScreen,
        previousState,
        {
          paramsData: updatedParamsData,
        }
      );
    }  
  };  
  
  const getPageTitle = useCallback(() => {  
    const [screenTitle, screenNumber] = isAddMode(currentMode) ? screenInfo.ADD : screenInfo.CHANGE;  
    return (  
      <>  
        <span className="title">{screenTitle}</span>  
        <span>{'-'}</span>  
        <span className="screen-number">{screenNumber}</span>  
      </>  
    );  
  }, [currentMode]);  
  
  const submitForm = async (dataForSubmission) => {  
    let url = '';  
    let verb = '';  
    let screenNumber = '';  
  
    if (isAddMode(currentMode)) {  
      url = 'api/cmmcopayminmaxpricing';  
      verb = 'POST';  
      screenNumber = screenInfo.ADD[1];  
    } else {  
      url = 'api/cmmcopayminmaxpricing';  
      verb = 'PUT';  
      screenNumber = screenInfo.CHANGE[1];  
    }  
  
    if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {  
      toast.current.show({ severity: 'info', summary: '', detail: 'No Change of Information', life: 3000 });  
      return;  
    }  
  
    const data = { ...dataForSubmission, screenNumber };  
  
    try {  
      const { responseStatus, responseData } = await axios_helper_no_header(verb, url, data, null);  
      toast.current.show({ severity: 'success', summary: '', detail: responseStatus.message, life: 3000 });  
      setInitialFormData(responseData);  
      if (isAddMode(currentMode)) {  
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
          currentState = {
            ...currentState,
            selectedCopaySteps: [{ ...responseData }],
            currentIndex: 0,
          };
          
          navigateToPage(ROUTE_PATHS.EDIT_MINMAX_COPAY_STEP, [
            ...previousState,
            currentState,
          ]);
        }
      }  
     catch (error) {  
      const { responseStatus: { displayErrorFields = null, message } } = error.data;  
      if (displayErrorFields === null) {  
        toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });  
      } else {  
        setConstraintErrors(displayErrorFields);  
      }  
    }  
  };  
  
  const [keyFunc, keyName] = useMemo(() => {  
    const keyFunc = {};  
    const keyName = {};  
  
    if (isAddMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
    } else if (isEditMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
      keyFunc.F11 = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);  
      keyName.F11 = 'View';  
    } else if (isReadOnlyMode(currentMode)) {  
      keyFunc.F12 = handleBack;  
      keyName.F12 = 'Back';  
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);  
      keyName.chmod = 'Edit';  
    }  
  
    return [keyFunc, keyName];  
  }, [currentMode, currentIndex]);  
  
  useEffect(() => {  
    console.log(previousState);
    const fetchInitialData = async () => {  
      let url = isAddMode(currentMode) ? `api/cmmcopayminmaxpricing/initial-form-data/${encodeURIComponent(paramsData.cmmPatientPayTable)}` : `api/cmmcopayminmaxpricing/${encodeURIComponent(selectedCopaySteps[currentIndex].cmmPatientPayTable)}?cmmStepNbr=${selectedCopaySteps[currentIndex].cmmStepNbr}`;  
      try{
        const { responseData } = await axios_helper_no_header('GET', url);  
        setInitialFormData(responseData);
      }
      catch(e){
console.log(e)
      }
    };  
  
    fetchInitialData();  
  }, [mode, currentIndex]);  
  
  return (  
    <div className="grid container">  
      <div className="col col-12">  
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
      </div>  
      <div className="col col-12">  
        <h1>{getPageTitle()}</h1>  
      </div>  
      <div className="col col-12">  
        <Form  
          formData={initialFormData}  
          formFields={formFields}  
          mode={currentMode}  
          submitFormData={submitForm}  
          constraintErrors={constraintErrors}  
        />  
      </div>  
    </div>  
  );  
};  
  
export default MinMaxCopayStepForm;  
